import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';

const SignaturePad = ({ onSave, onSignatureChange, height = 200, width = 500, hideInterface = false, backgroundColor = "rgba(249, 250, 251, 1)" }) => {
  const sigCanvas = useRef(null);
  const containerRef = useRef(null);
  const [isSigned, setIsSigned] = useState(false);
  const [canvasWidth, setCanvasWidth] = useState(width);
  
  // Add resize listener to make the signature pad responsive
  React.useEffect(() => {
    const updateDimensions = () => {
      if (containerRef.current) {
        // Calculate the container width and adjust canvas accordingly
        const containerWidth = containerRef.current.offsetWidth;
        // Use the smaller of the container width or the provided width
        setCanvasWidth(Math.min(containerWidth, width));
      }
    };
    
    // Update on mount
    updateDimensions();
    
    // Update on resize
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, [width]);

  const clear = () => {
    sigCanvas.current.clear();
    setIsSigned(false);
  };

  const save = () => {
    if (sigCanvas.current.isEmpty()) {
      alert('Please provide a signature first');
      return;
    }
    
    const signatureData = sigCanvas.current.toDataURL('image/png');
    
    if (onSave) {
      onSave(signatureData);
    } else if (onSignatureChange) {
      onSignatureChange(signatureData);
    }
  };

  // Handle signature changes for direct canvas updates
  const handleEnd = () => {
    setIsSigned(true);
    // Remove auto-save - let user continue drawing multiple strokes
  };

  return (
    <div className="signature-container w-full">
      <div 
        ref={containerRef} 
        className={`border ${hideInterface ? '' : 'border-2'} border-gray-300 rounded-lg ${!hideInterface && 'mb-4'} bg-gray-50 w-full`}
      >
        <SignatureCanvas
          ref={sigCanvas}
          penColor="black"
          canvasProps={{
            width: canvasWidth,
            height: height,
            className: 'signature-canvas',
            style: { backgroundColor, width: '100%', height: '100%' }
          }}
          onEnd={handleEnd}
        />
      </div>
      
      {/* Only show clear button */}
      {!hideInterface && (
        <div className="flex gap-4 justify-end">
          <button
            type="button"
            onClick={clear}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 transition font-medium"
          >
            Clear
          </button>
        </div>
      )}
    </div>
  );
};

export default SignaturePad;